import { Button, Notification } from '@components/shared';
import { create } from '@shared/typedApi';
import routes from '@root/routes';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@tanstack/react-query';

type Props = {
  refetch: () => void;
  buildingId: string;
};

export default function NewMicrosite({ refetch, buildingId }: Props) {
  const { t } = useTranslation('admin');
  const mutation = useMutation(() => create(routes.api.admin.buildingMicrosite(buildingId), {}), {
    onSuccess: () => {
      Notification.success({
        title: t('common:changesSaved'),
        placement: 'topRight',
      });
      refetch();
    },
  });
  return (
    <section>
      <Button onClick={() => mutation.mutate()}>{t('microsite.createText')}</Button>
    </section>
  );
}
